import { createListFilters, IOption } from 'app/components'

export type MedicamentosFilters = {
  /** Nome do medicamento (busca parcial). */
  nome: string
  situacao?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<MedicamentosFilters>({
  nome: '',
  situacao: undefined,
})
